module.exports = __webpack_public_path__ + "img/BI_8.20a196a4.png";